export const FLIGHT_FROM_QUERY_PARAM = 'from';
export const FLIGHT_TO_QUERY_PARAM = 'to';
export const FLIGHT_START_DATE_QUERY_PARAM = 'startDate';
export const FLIGHT_TRIP_TYPE_QUERY_PARAM = 'tripType';
export const FLIGHT_SEGMENT_COUNT_QUERY_PARAM = 'segmentCount';
export const FLIGHT_SOURCE_QUERY_PARAM = 'source';
export const FLIGHT_TRIP_TYPE_MULTICITY = 'multicity';
export const FLIGHT_SOURCE_CHATBOT = 'chatbot';
